module.exports = "/images/jrpay-icon.png";